import { useUiStore, type ViewMode } from '@/state/uiStore';

// "Sliced" was dropped: peel is now always live (see StoryPeel), so the
// slider is the single source of truth for "show me inside the house".
const MODES: Array<{ id: ViewMode; label: string; hint: string }> = [
  { id: 'exterior', label: 'Exterior', hint: 'Default orbit view' },
  { id: 'topDown', label: 'Top-down', hint: 'Overhead orthographic' },
  { id: 'wireframeDebug', label: 'Debug', hint: 'Wireframe + overlays' },
];

export function ViewModes() {
  const viewMode = useUiStore((s) => s.viewMode);
  const setViewMode = useUiStore((s) => s.setViewMode);
  const debug = useUiStore((s) => s.debug);
  const showContext = useUiStore((s) => s.showContext);
  const setShowContext = useUiStore((s) => s.setShowContext);
  const egoMode = useUiStore((s) => s.egoMode);
  const setEgoMode = useUiStore((s) => s.setEgoMode);

  return (
    <nav className="viewmodes panel" aria-label="View modes">
      {MODES.filter((m) => debug || m.id !== 'wireframeDebug').map((m) => (
        <button
          key={m.id}
          type="button"
          className={viewMode === m.id ? 'primary' : ''}
          onClick={() => setViewMode(m.id)}
          title={m.hint}
          aria-pressed={viewMode === m.id}
        >
          {m.label}
        </button>
      ))}
      <button
        type="button"
        className={showContext ? '' : 'primary'}
        onClick={() => setShowContext(!showContext)}
        title={showContext ? 'Hide lot, fence, mailbox' : 'Show lot, fence, mailbox'}
        aria-pressed={!showContext}
      >
        {showContext ? 'House only' : 'With site'}
      </button>
      {/* Ego / first-person walk mode. The click is a user gesture, which
       *  is required for the browser to grant pointer lock — we kick off
       *  the state flip here and App.tsx picks it up to call enterEgoMode
       *  synchronously on the same tick. */}
      <button
        type="button"
        className={egoMode ? 'primary' : ''}
        onClick={() => setEgoMode(!egoMode)}
        title={egoMode ? 'Exit walk-around mode' : 'Drop in at the front gate and explore'}
        aria-pressed={egoMode}
      >
        {egoMode ? 'Exit Ego' : 'Ego'}
      </button>
    </nav>
  );
}
